import { MenuItem } from "./MenuItem";
import { Flavour } from "./Flavour";
import { User } from "./User";
import {MyLocation} from "./Location";
import {Restaurant} from "./Restaurant";
import {PaystackPayment} from "./PaystackPayment";

export class OrderItem {

    private _id:           number;
    private _user:         User;
    private _menu_item:     MenuItem;
    private _flavour:      Flavour;
    private _quantity:     number;
    private _orderTime:    Date;
    private _deliveryTime: Date | null;
    private _location:MyLocation
    private _restaurant_count: number
    private _paystack_payment :PaystackPayment
    private _restaurant: Restaurant
    private _is_ordered: boolean
    private _is_completed: boolean
    private _order_time: Date
    private _is_cancelled: boolean
    private _driver: User;
    private _seller_withdrew:  boolean;


    constructor() {
        this._id           = 0;
        this._user         = new User();
        this._menu_item    = new MenuItem();
        this._flavour      = new Flavour();
        this._quantity     = 0;
        this._orderTime    = new Date();
        this._deliveryTime = null;
        this._location     = new MyLocation()
        this._restaurant_count = 0;
        this._is_completed = false;
        this._is_ordered   = false;
        this._restaurant   = new Restaurant();
        this._order_time   = new Date();
        this._is_cancelled = false;
        this._driver       = new User();
        this._seller_withdrew = false;
        this._paystack_payment = new PaystackPayment()
    }

    get id(): number { return this._id; }
    set id(value: number) { this._id = value; }

    get user(): User { return this._user; }
    set user(value: User) { this._user = value; }

    get flavour(): Flavour { return this._flavour; }
    set flavour(value: Flavour) { this._flavour = value; }

    get quantity(): number { return this._quantity; }
    set quantity(value: number) { this._quantity = value; }

    get orderTime(): Date { return this._orderTime; }
    set orderTime(value: Date) { this._orderTime = value; }

    get deliveryTime(): Date | null { return this._deliveryTime; }
    set deliveryTime(value: Date | null) { this._deliveryTime = value; }

    get location(): MyLocation { return this._location; }
    set location(value: MyLocation) { this._location = value; }

    get menu_item(): MenuItem { return this._menu_item; }
    set menu_item(value: MenuItem) { this._menu_item = value; }

    get restaurant_count(): number { return this._restaurant_count; }
    set restaurant_count(value: number) { this._restaurant_count = value; }

    get is_ordered(): boolean { return this._is_ordered; }
    set is_ordered(value: boolean) { this._is_ordered = value; }

    get is_completed(): boolean { return this._is_completed; }
    set is_completed(value: boolean) { this._is_completed = value; }

    get restaurant(): Restaurant { return this._restaurant; }
    set restaurant(value: Restaurant) { this._restaurant = value; }

    get order_time(): Date { return this._order_time; }
    set order_time(value: Date) { this._order_time = value; }

    get is_cancelled(): boolean { return this._is_cancelled; }
    set is_cancelled(value: boolean) { this._is_cancelled = value; }

    get driver(): User { return this._driver; }
    set driver(value: User) { this._driver = value; }

    get seller_withdrew(): boolean { return this._seller_withdrew; }
    set seller_withdrew(value: boolean) { this._seller_withdrew = value; }


    get paystack_payment(): PaystackPayment {
        return this._paystack_payment;
    }

    set paystack_payment(value: PaystackPayment) {
        this._paystack_payment = value;
    }
}